import type {ReactElement} from 'react';
import React from 'react';
import {Image} from 'react-bootstrap';
import {Text, TextSize} from '@Components/text';
import {getAssetUrl} from '@Utils/s3.util';
import {DragDropOverlay} from '@Components/drag-drop-overlay/drag-drop-overlay';
import {AI_PROMPT_BOX_ACCEPTED_IMAGE_TYPES} from '@Components/ai-prompt-box/libraries/ai-prompt-box-drag-drop.library';
import {useAiPromptBoxDragDropUploader} from '@Components/ai-prompt-box/hooks/useAiPromptBoxDragDropUploader';
import type {AiChatDragDropOverlayProps} from './ai-chat-drag-drop-overlay.types';
import styles from './ai-chat-drag-drop-overlay.module.scss';

export function AiChatDragDropOverlay({promptBoxId, targetElement}: AiChatDragDropOverlayProps): ReactElement {
  const {handleFiles, showInvalidFileTypeError} = useAiPromptBoxDragDropUploader(promptBoxId);

  const hoverContent = (
    <div className={`_full-width _full-height ${styles.content}`}>
      <Image className={styles.overlayImage} src={getAssetUrl('ai-chat-drag-drop-overlay-image.webp')} alt={window.i18next.t('pmwjs_ai_chat_drag_drop_heading')} />
      <Text className={`spacing-m-t-4 content-body-white`} val={window.i18next.t('pmwjs_ai_chat_drag_drop_heading')} size={TextSize.LARGE} bold />
      <Text className="content-body-white" val={window.i18next.t('pmwjs_ai_chat_drag_drop_description')} size={TextSize.SMALL} />
    </div>
  );

  return (
    <DragDropOverlay
      onFilesUpload={handleFiles}
      onHoverContent={hoverContent}
      className={styles.container}
      acceptedTypes={AI_PROMPT_BOX_ACCEPTED_IMAGE_TYPES}
      onInvalidFileTypeError={showInvalidFileTypeError}
      targetElement={targetElement}
    />
  );
}
